export const disableGlobalErrorReportingForMatches = [{
  errorCode: 'TIMEOUT'
}, {
  errorMessage: 'Aborting: redirection in progress'
}, {
  errorMessage: 'failed with status 0'
}, {
  errorMessage: 'failed with status 403'
}, {
  errorMessage: 'failed with status 401'
}];